'use client';

import React, { useEffect } from 'react';
import LayoutDashboard from '@/components/Dashboard';
import { Button, Result } from 'antd';
import { useStore } from '@/store/zustand-solicitud';
import { useRouter } from 'next/navigation';
import Lottie from 'react-lottie-player';
import logo404 from '@/components/ui/animations/404.json';
import { sufijoModoAsistido } from '@/utils/services/modoAsistido';
import styles from './NotFoundPage.module.scss';

const NotFoundPage: React.FC = () => {
	const { setNavbarVisible, entidadId, type } = useStore();
	const router = useRouter();

	useEffect(() => {
		setNavbarVisible(false);
	}, []);

	const redirect = () => {
		if (entidadId) {
			// Ver sufijoModoAsistido: esta url se rearma desde cero y sin esto el operador vuelve en
			// modo autoasistido, con el check de terminos que no puede aceptar (AB#10758).
			const modoAsistidoRoute = sufijoModoAsistido();
			if (type) {
				router.push(`/?e=${entidadId}&t=${type}` + modoAsistidoRoute);
			} else {
				router.push('/?e=' + entidadId + modoAsistidoRoute);
			}
		} else {
			router.push('/');
		}
	};

	return (
			<div className={styles.container}>
				<Result
					className={styles.content}
					title="404"
					subTitle="La página que buscas no existe o no está disponible en este momento"
					icon={
						<div className={styles.animation}>
							<Lottie className={styles.lottie} animationData={logo404} play />
						</div>
					}
					extra={
						entidadId && (
							<Button onClick={redirect} type="primary">
								Volver al inicio
							</Button>
						)
					}
				/>
			</div>
	);
};

export default NotFoundPage;
